/* Bechose · menu desktop: flyout do 3º nível.
   Ao passar o mouse numa subcategoria, ela fica ativa e sua lista de modelos
   aparece ao lado; a última ativa continua aberta até outra ser apontada,
   para o cursor poder atravessar a lista sem fechar o painel. */
(function () {
  function init(root) {
    root.querySelectorAll('[data-bch-flyout-family]').forEach(function (family) {
      var items = family.querySelectorAll('[data-bch-flyout-item]');
      function activate(item) {
        items.forEach(function (i) { i.classList.toggle('is-active', i === item); });
      }
      items.forEach(function (item) {
        item.addEventListener('mouseenter', function () { activate(item); });
        item.addEventListener('focusin', function () { activate(item); });
      });
      family.addEventListener('mouseleave', function () { activate(null); });
    });
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
